import { configureBearerTokenAPI } from '../configuration/bearerToken'
import { AxiosApi } from './axiosApi'

export class BearerTokenApi extends AxiosApi {
  constructor({ domain }: { domain: string }) {
    super(configureBearerTokenAPI(domain))
  }
}
